import { signal } from '@preact/signals-react';

/**
 * Bumped whenever time-off data is mutated from outside the Time Off List
 * (e.g. the batch-create screen). An open list watches this and refetches its
 * own selected day — the list owns which day to query, so callers only signal
 * "data changed" instead of dispatching a range they cannot know.
 */
export const timeOffRefreshSignal = signal(0);

export const requestTimeOffRefresh = () => {
  timeOffRefreshSignal.value += 1;
};
